import { ConsultationState, ExpertRequestStage, ExpertRequestState } from '@/__generated__/graphql';

import { effectiveStage } from './effectiveStage';

// Mirrors consultation.OpenStates (api consultation/service/consultation.go): the
// non-terminal states that block closing an ER (ENG-5318 Gate 2). Kept in sync so the
// Close modal can pre-empt the server's expertrequest.has_open_consultations rejection.
export const OPEN_CONSULTATION_STATES: ReadonlySet<ConsultationState> = new Set([
  ConsultationState.NegotiatingExpertTime,
  ConsultationState.NegotiatingClientTime,
  ConsultationState.Confirmed,
  ConsultationState.AwaitingJoin,
  ConsultationState.AwaitingClientJoin,
  ConsultationState.AwaitingExpertJoin,
  ConsultationState.AwaitingExpertReview,
  ConsultationState.AwaitingClientAccept,
  ConsultationState.InProgress,
  ConsultationState.Finalizing,
]);

export function countOpenConsultations(
  consultations: ReadonlyArray<{ state?: ConsultationState | null }>
): number {
  return consultations.filter((c) => c.state && OPEN_CONSULTATION_STATES.has(c.state)).length;
}

// Consultations/calls require an Active ER (ENG-5318 Gate 1); undefined ER leaves the CTA enabled.
export function requestConsultationDisabled(
  er?: { stage?: ExpertRequestStage | null; state?: ExpertRequestState | string | null } | null
): boolean {
  return !!er && effectiveStage(er.stage, er.state) !== ExpertRequestStage.Active;
}
